import {
  LOGIN,
  LOGIN_ERROR,
  RESET_LOGIN_ERROR,
  LOGOUT,
  SET_USER,
} from "../actions/types";

const initialState = {
  error: null,
  loggedIn: false,
  userDetails: null,
};

// eslint-disable-next-line
export default function (state = initialState, action) {
  switch (action.type) {
    case SET_USER:
      return {
        ...state,
        userDetails: action.payload
      };
    case LOGIN:
      return {
        error: null,
        loggedIn: true,
      };
    case LOGIN_ERROR:
      return {
        error: action.payload,
      };
    case RESET_LOGIN_ERROR:
      return {
        error: null,
      };
    case LOGOUT:
      return {
        loggedIn: false,
      };

    default:
      return state;
  }
}
